export default __webpack_public_path__ + "static/media/home.7b654c2f.jpg";